export enum EsignatureType {
  Adobesign = 'adobesign',
  Docusign = 'docusign',
}
